import React from "react";
import { Route, Switch } from "react-router-dom";
import UserManagementTable from "./UserManagementTable";
import UserManagementForm from "./UserManagementForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/users" component={UserManagementTable} />
    <WriteRoute
      exact
      path="/users/addnew"
      component={UserManagementForm}
      redirectTo="/users"
    />
  </Switch>
);
